/**
 * product-page-premium.js
 * Variant selection (swatches/pills -> matching variant -> price/
 * availability/id update, no page reload), gallery navigation, zoom
 * lightbox, quantity stepper, AJAX add-to-cart, and a dynamic WhatsApp
 * buy link built from the current product/variant/quantity.
 */
(function () {
  'use strict';

  var root = document.querySelector('.pp-product');
  if (!root) return;

  var variantsJsonEl = document.querySelector('[data-pp-product-json]');
  var variants = [];
  try {
    variants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : [];
  } catch (e) {
    variants = [];
  }

  var variantIdInput = root.querySelector('[data-pp-variant-id]');
  var priceEl = root.querySelector('[data-pp-price]');
  var availabilityEl = root.querySelector('[data-pp-availability]');
  var addToCartBtn = root.querySelector('[data-pp-add-to-cart]');
  var whatsappLink = root.querySelector('[data-pp-whatsapp-link]');
  var qtyInput = root.querySelector('[data-pp-qty-input]');

  function moneyFormat(cents) {
    return 'Rs.' + (cents / 100).toFixed(2);
  }

  /* ---------------------------------------------------------------------
   * Variant selection
   * ------------------------------------------------------------------- */
  function getSelectedOptions() {
    var selected = [];
    root.querySelectorAll('[data-pp-option-position]').forEach(function (group) {
      var position = parseInt(group.dataset.ppOptionPosition, 10);
      var active = group.querySelector('.is-active[data-pp-option-select]');
      if (active) selected[position - 1] = active.dataset.optionValue;
    });
    return selected;
  }

  function findMatchingVariant(selected) {
    return variants.find(function (variant) {
      return variant.options.every(function (opt, idx) {
        return opt === selected[idx];
      });
    });
  }

  function updateForVariant(variant) {
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML =
          '<span class="pp-buybox__price--sale">' + moneyFormat(variant.price) + '</span>' +
          '<span class="pp-buybox__price--compare">' + moneyFormat(variant.compare_at_price) + '</span>';
      } else {
        priceEl.innerHTML = '<span>' + moneyFormat(variant.price) + '</span>';
      }
    }

    if (availabilityEl) {
      if (variant.available) {
        availabilityEl.innerHTML = '<span class="pp-availability__dot pp-availability__dot--in-stock"></span> In stock, ready to ship';
      } else {
        availabilityEl.innerHTML = '<span class="pp-availability__dot pp-availability__dot--out"></span> Out of stock';
      }
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      addToCartBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    updateWhatsAppLink(variant);

    if (variant.featured_media && variant.featured_media.id) {
      var targetSlide = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (targetSlide) {
        var targetIndex = parseInt(targetSlide.dataset.ppSlide, 10);
        if (!isNaN(targetIndex)) goToSlide(targetIndex);
      }
    }

    // Update the URL's variant param without a full reload, so refreshes
    // and shared links keep the selected variant.
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  root.querySelectorAll('[data-pp-option-select]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('[data-pp-option-position]');
      group.querySelectorAll('[data-pp-option-select]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');

      var labelEl = group.querySelector('[data-pp-option-value]');
      if (labelEl) labelEl.textContent = btn.dataset.optionValue;

      var selected = getSelectedOptions();
      var matched = findMatchingVariant(selected);
      if (matched) updateForVariant(matched);
    });
  });

  /* ---------------------------------------------------------------------
   * Gallery
   * ------------------------------------------------------------------- */
  var slides = root.querySelectorAll('[data-pp-slide]');
  var thumbs = root.querySelectorAll('[data-pp-thumb]');
  var currentSlide = 0;

  function goToSlide(index) {
    if (slides.length === 0) return;
    if (index >= slides.length) index = 0;
    if (index < 0) index = slides.length - 1;
    slides[currentSlide].classList.remove('is-active');
    thumbs[currentSlide] && thumbs[currentSlide].classList.remove('is-active');
    currentSlide = index;
    slides[currentSlide].classList.add('is-active');
    thumbs[currentSlide] && thumbs[currentSlide].classList.add('is-active');
  }

  var prevBtn = root.querySelector('[data-pp-gallery-prev]');
  var nextBtn = root.querySelector('[data-pp-gallery-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentSlide - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentSlide + 1); });

  thumbs.forEach(function (thumb, idx) {
    thumb.addEventListener('click', function () { goToSlide(idx); });
  });

  // Mouse/touch drag-to-swipe on the main gallery frame.
  (function initSwipe() {
    var frame = root.querySelector('[data-pp-zoom-frame]');
    if (!frame) return;

    var startX = 0;
    var startY = 0;
    var isDragging = false;
    var DRAG_THRESHOLD = 40;

    function onPointerDown(event) {
      var point = event.touches ? event.touches[0] : event;
      startX = point.clientX;
      startY = point.clientY;
      isDragging = true;
    }

    function onPointerUp(event) {
      if (!isDragging) return;
      isDragging = false;
      var point = event.changedTouches ? event.changedTouches[0] : event;
      var deltaX = point.clientX - startX;
      var deltaY = point.clientY - startY;

      // Ignore mostly-vertical drags (likely a page scroll attempt).
      if (Math.abs(deltaX) < DRAG_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;

      if (deltaX < 0) {
        goToSlide(currentSlide + 1);
      } else {
        goToSlide(currentSlide - 1);
      }
    }

    frame.addEventListener('mousedown', onPointerDown);
    frame.addEventListener('mouseup', onPointerUp);
    frame.addEventListener('mouseleave', function () { isDragging = false; });
    frame.addEventListener('touchstart', onPointerDown, { passive: true });
    frame.addEventListener('touchend', onPointerUp);

    // Prevent the click-to-zoom handler from firing right after a drag.
    frame.addEventListener('click', function (event) {
      if (Math.abs(event.clientX - startX) > 10) {
        event.stopImmediatePropagation();
      }
    }, true);
  })();

  /* ---------------------------------------------------------------------
   * Zoom lightbox
   * ------------------------------------------------------------------- */
  var lightbox = document.querySelector('[data-pp-lightbox]');
  var lightboxImageWrap = document.querySelector('[data-pp-lightbox-image-wrap]');
  var zoomOpenBtn = root.querySelector('[data-pp-zoom-open]');
  var zoomFrame = root.querySelector('[data-pp-zoom-frame]');
  var zoomCloseBtn = document.querySelector('[data-pp-zoom-close]');
  var zoomOverlay = document.querySelector('[data-pp-zoom-overlay]');

  function openLightbox() {
    if (!lightbox || !lightboxImageWrap) return;
    var activeImg = slides[currentSlide] && slides[currentSlide].querySelector('img');
    if (!activeImg) return;
    lightboxImageWrap.innerHTML = '<img src="' + (activeImg.currentSrc || activeImg.src) + '" alt="">';
    lightbox.hidden = false;
    void lightbox.offsetHeight;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (zoomOpenBtn) zoomOpenBtn.addEventListener('click', openLightbox);
  if (zoomFrame) zoomFrame.addEventListener('click', openLightbox);
  if (zoomCloseBtn) zoomCloseBtn.addEventListener('click', closeLightbox);
  if (zoomOverlay) zoomOverlay.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) closeLightbox();
  });

  /* ---------------------------------------------------------------------
   * Quantity
   * ------------------------------------------------------------------- */
  var qtyDecrease = root.querySelector('[data-pp-qty-decrease]');
  var qtyIncrease = root.querySelector('[data-pp-qty-increase]');

  function updateQty(delta) {
    if (!qtyInput) return;
    var newVal = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
    qtyInput.value = newVal;
    var current = variants.find(function (v) { return String(v.id) === String(variantIdInput && variantIdInput.value); });
    updateWhatsAppLink(current);
  }
  if (qtyDecrease) qtyDecrease.addEventListener('click', function () { updateQty(-1); });
  if (qtyIncrease) qtyIncrease.addEventListener('click', function () { updateQty(1); });
  if (qtyInput) qtyInput.addEventListener('change', function () { updateQty(0); });

  /* ---------------------------------------------------------------------
   * WhatsApp dynamic link
   * ------------------------------------------------------------------- */
  function updateWhatsAppLink(variant) {
    if (!whatsappLink) return;
    var number = whatsappLink.dataset.whatsappNumber || '';
    var template = whatsappLink.dataset.whatsappTemplate || '';
    var qty = qtyInput ? qtyInput.value : 1;
    var price = variant ? moneyFormat(variant.price) : '';
    var title = document.title.split(' – ')[0] || document.title;
    var titleEl = root.querySelector('.pp-buybox__title');
    if (titleEl) title = titleEl.textContent.trim();

    var message = template
      .replace('[product_title]', title)
      .replace('[product_price]', price)
      .replace('[product_url]', window.location.href)
      .replace('[quantity]', qty);

    whatsappLink.href = 'https://wa.me/' + number.replace(/[^0-9]/g, '') + '?text=' + encodeURIComponent(message);
  }

  // Initialize WhatsApp link on load with the initially selected variant.
  (function initWhatsApp() {
    var initialVariant = variants.find(function (v) { return String(v.id) === String(variantIdInput && variantIdInput.value); }) || variants[0];
    updateWhatsAppLink(initialVariant);
  })();

  /* ---------------------------------------------------------------------
   * AJAX add to cart
   * ------------------------------------------------------------------- */
  var form = document.getElementById('ProductForm');
  if (form) {
    form.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      // Let "Buy it now" (name="checkout") submit natively to go straight
      // to checkout — only intercept the plain "Add to Cart" submit.
      if (submitter && submitter.name === 'checkout') return;

      event.preventDefault();
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Adding...';
      }

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (addToCartBtn) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = 'Added ✓';
            window.setTimeout(function () { addToCartBtn.textContent = 'Add to Cart'; }, 1800);
          }
          // If a premium header cart drawer (from the header package) is
          // installed on this theme, this opens it automatically.
          document.dispatchEvent(new CustomEvent('premium:cart:add', {
            detail: { id: formData.get('id'), quantity: formData.get('quantity') || 1 }
          }));
        })
        .catch(function () {
          if (addToCartBtn) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = 'Add to Cart';
          }
          window.location.href = '/cart';
        });
    });
  }

})();

/* ---------------------------------------------------------------------
 * Product recommendations
 * Shopify only populates the `recommendations` object when a section is
 * fetched via its dedicated recommendations endpoint — on a normal page
 * load it renders empty. This fetches that endpoint and swaps in the
 * populated markup.
 * ------------------------------------------------------------------- */
(function () {
  var recEl = document.querySelector('.pp-recs[data-url]');
  if (!recEl) return;

  fetch(recEl.dataset.url)
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newContent = doc.querySelector('.pp-recs');
      if (newContent && newContent.innerHTML.trim()) {
        recEl.innerHTML = newContent.innerHTML;
      }
    })
    .catch(function () {
      /* leave section empty on failure -- no broken UI */
    });
})();

/* ---------------------------------------------------------------------
 * Write a Review modal
 * ------------------------------------------------------------------- */
(function () {
  var modal = document.querySelector('[data-pr-modal]');
  var openBtn = document.querySelector('[data-pr-open-form]');
  var closeEls = document.querySelectorAll('[data-pr-close]');
  var starPicker = document.querySelector('[data-pr-star-picker]');
  var ratingInput = document.querySelector('[data-pr-rating-input]');

  function openModal() {
    if (!modal) return;
    modal.hidden = false;
    void modal.offsetHeight;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (openBtn) openBtn.addEventListener('click', openModal);
  closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
  });

  // If the form was just submitted successfully (Shopify reloads the page
  // with the section re-rendered showing a success message), auto-open
  // the modal so the confirmation is visible instead of buried on page.
  if (document.querySelector('[data-pr-success]')) openModal();

  if (starPicker && ratingInput) {
    var stars = starPicker.querySelectorAll('[data-value]');

    function setRating(value) {
      ratingInput.value = value;
      stars.forEach(function (star) {
        star.classList.toggle('is-active', parseInt(star.dataset.value, 10) <= value);
      });
    }

    stars.forEach(function (star) {
      star.addEventListener('click', function () { setRating(parseInt(star.dataset.value, 10)); });
      star.addEventListener('mouseenter', function () {
        var hoverValue = parseInt(star.dataset.value, 10);
        stars.forEach(function (s) {
          s.classList.toggle('is-hover', parseInt(s.dataset.value, 10) <= hoverValue);
        });
      });
      star.addEventListener('mouseleave', function () {
        stars.forEach(function (s) { s.classList.remove('is-hover'); });
      });
    });

    setRating(5);
  }
})();
